__turbopack_context__.v({
  "content": "eHqJmq_content",
  "content-reverse": "eHqJmq_content-reverse",
  "description": "eHqJmq_description",
  "description-1": "eHqJmq_description-1",
  "description-2": "eHqJmq_description-2",
  "highlight": "eHqJmq_highlight",
  "root": "eHqJmq_root",
});
